import { render, staticRenderFns } from "./PostCreator.vue?vue&type=template&id=0fcb6eb5&v-if=draftInstance"
import script from "./PostCreator.vue?vue&type=script&lang=js"
export * from "./PostCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fcb6eb5')) {
      api.createRecord('0fcb6eb5', component.options)
    } else {
      api.reload('0fcb6eb5', component.options)
    }
    module.hot.accept("./PostCreator.vue?vue&type=template&id=0fcb6eb5&v-if=draftInstance", function () {
      api.rerender('0fcb6eb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/PostCreator.vue"
export default component.exports